// extracted by mini-css-extract-plugin
export var productImage = "_r1-1";
export var viewLink = "_r1-2";
export var wishlistItem = "_r1-0";